import { Redirect } from "react-router-dom"
import React, { useState } from "react"

export default function Search() {
  const [redirect, setRedirect] = useState(false)

  const handleFocus = () => {
    setRedirect(true)
  }

  return (
    <div className="input-box">
      <ion-icon name="search"></ion-icon>
      <input type="text" placeholder="Search Items..." onFocus={handleFocus} />
      {redirect && <Redirect to="/search" />}
    </div>
  )
}
